import script from "./LotterySection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotterySection.vue?vue&type=script&setup=true&lang=ts"

import "./LotterySection.vue?vue&type=style&index=0&id=5978c1fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5978c1fc"]])

export default __exports__